<template>
  <VkVideoPlayer v-if="isVkVideo" :src="src" @play="isPlay = $event" />
  <YoutubePlayer v-else :id="id" :src="src" :isSlider="isSlider" />
</template>

<script>
import VkVideoPlayer from './VkVideoPlayer.vue'
import YoutubePlayer from './YoutubePlayer.vue'

export default {
  name: 'VideoPlayer',
  props: {
    isSlider: Boolean,
    id: String,
    src: String,
  },
  components: {
    YoutubePlayer,
    VkVideoPlayer,
  },
  computed: {
    isVkVideo() {
      try {
        const url = new URL(this.src)
        return ['vk.com', 'vkvideo.ru'].some((h) => url.host.includes(h))
      } catch (e) {
        console.error(e)
        return false
      }
    },
  },
  data() {
    return {
      isPlay: false,
    }
  },
}
</script>
